// GENERATED by scripts/build-icons.mjs from icons/corner-down-left.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const CornerDownLeft = createIcon('corner-down-left', [
  ['path', { d: "M20 4v7a4 4 0 0 1-4 4H4" }],
  ['path', { d: "m9 10-5 5 5 5" }],
])
